import urlcat from "urlcat";

import { Staff } from "@/interfaces/IAuth";
import { axiosInstance, parseResponse, TENANT_API_URL } from "..";

export const STAFF_URL = `${TENANT_API_URL}/staff`;

export const getStaff = async (data?: any) => {
  try {
    const url = urlcat(`${STAFF_URL}/list`, data);
    const response = await axiosInstance.post(url, data);
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const getStaffList = async (data?: any) => {
  try {
    const url = urlcat(`${STAFF_URL}/list`, data);
    const response = await axiosInstance.post(url, data);
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const getStaffForRoster = async (data?: any) => {
  try {
    const response = await axiosInstance.post(
      `${STAFF_URL}/roster-staff`,
      data
    );
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const getStaffAsync = ({
  page,
  query,
  limit,
  sort,
  jobRoles,
  status,
  includeMe,
}: any) => {
  const url = urlcat(`${STAFF_URL}/list`, {
    query,
    page,
    limit,
    sort,
    includeMe,
  });
  return axiosInstance.post(url, { jobRoles, status });
};

export const getStaffById = async (id: string | undefined) => {
  try {
    if (!id || !/^[a-zA-Z0-9_-]+$/.test(id)) {
      throw new Error("Invalid ID");
    }
    const response = await axiosInstance.get(`${STAFF_URL}/${id}`);
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const getStaffByIdAsync = (id: string | undefined) => {
  if (!id || !/^[a-zA-Z0-9_-]+$/.test(id)) {
    throw new Error("Invalid ID");
  }
  return axiosInstance.get(`${STAFF_URL}/${id}`);
};

export const getCurrentStaffUser = async () => {
  try {
    const response = await axiosInstance.get(`${STAFF_URL}/user`);
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const createStaff = async (data: any) => {
  try {
    const response = await axiosInstance.post(`${STAFF_URL}`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const createStaffAsync = (data: any) =>
  axiosInstance.post(`${STAFF_URL}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const updateStaff = async (id: string | undefined, data: any) => {
  try {
    if (!id || !/^[a-zA-Z0-9_-]+$/.test(id)) {
      throw new Error("Invalid ID");
    }
    const response = await axiosInstance.put(`${STAFF_URL}/${id}`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const updateStaffAsync = (id: string | undefined, data: any) => {
  if (!id || !/^[a-zA-Z0-9_-]+$/.test(id)) {
    throw new Error("Invalid ID");
  }
  return axiosInstance.put(`${STAFF_URL}/${id}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const deleteStaff = async (id: string | undefined) => {
  try {
    if (!id || !/^[a-zA-Z0-9_-]+$/.test(id)) {
      throw new Error("Invalid ID");
    }
    const response = await axiosInstance.delete(`${STAFF_URL}/${id}`);
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const deleteStaffAsync = (id: string | undefined) => {
  if (!id || !/^[a-zA-Z0-9_-]+$/.test(id)) {
    throw new Error("Invalid ID");
  }
  return axiosInstance.delete(`${STAFF_URL}/${id}`);
};

export const getUpcomingBirthdays = async (skip: number) => {
  try {
    const response = await axiosInstance.get(
      `${STAFF_URL}/upcoming-birthdays?skip=${skip}`
    );
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const getStaffChartData = async () => {
  try {
    const response = await axiosInstance.get(`${STAFF_URL}/occupancy-graph`);
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const getJobRoles = async () => {
  try {
    const response = await axiosInstance.get(`${STAFF_URL}/jobRoles`);
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const sendReinviteMail = async (data: any) => {
  try {
    const response = await axiosInstance.post(
      `${STAFF_URL}/send-reinvite`,
      data
    );
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const updatePassword = async (data: any) => {
  try {
    const response = await axiosInstance.put(
      `${STAFF_URL}/update-password`,
      data
    );
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const getAlertSettings = async () => {
  try {
    const response = await axiosInstance.get(`${STAFF_URL}/alert-settings`);
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const updateAlertSettings = async (
  data: Pick<Staff, "alertSettings">
) => {
  try {
    const response = await axiosInstance.put(
      `${STAFF_URL}/alert-settings`,
      data
    );
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};
